/* eslint-disable @reatom/unit-naming-rule */
import { action, atom, withAssign } from '@reatom/framework'

import { AsyncStateN, pipe, Set } from '@blade/std-lib'
import { isLoggedInAtom } from '@root/entities/auth/atoms'
import { reatomSetComputed } from '@root/shared/lib/reatom'

import { blacklistCurrenciesLocalModel } from './reatom-blacklist-currencies-local'
import { blacklistCurrenciesRemoteModel } from './reatom-blacklist-currencies-remote'

import type { CurrencyModel, CurrencyRef } from '@root/entities/currency/model'

export const reatomBlacklistCurrencies = () => {
  const hideAction = action(async (ctx, currency: CurrencyModel) => {
    const isLoggedIn = ctx.get(isLoggedInAtom)
    if (isLoggedIn) {
      blacklistCurrenciesRemoteModel.hide(ctx, currency)
      return
    }
    blacklistCurrenciesLocalModel.hide(ctx, currency)
  }, 'hideCurrencyLocalAction')

  const unhideAction = action(async (ctx, currency: CurrencyRef.Ref) => {
    const isLoggedIn = ctx.get(isLoggedInAtom)
    if (isLoggedIn) {
      blacklistCurrenciesRemoteModel.unhide(ctx, currency)
      return
    }
    blacklistCurrenciesLocalModel.unhide(ctx, currency)
  }, 'unhideCurrencyLocalAction')

  const stateAtom = atom((ctx) => {
    const isLoggedIn = ctx.spy(isLoggedInAtom)
    if (isLoggedIn) {
      const state = ctx.spy(blacklistCurrenciesRemoteModel)
      return pipe(
        state,
        AsyncStateN.map((it) =>
          it.map((it) => (it.currency ? it.currency : it.ref)),
        ),
      )
    }
    return ctx.spy(blacklistCurrenciesLocalModel)
  })

  const blacklistedAddressesAtom = reatomSetComputed((ctx) => {
    const isLoggedIn = ctx.spy(isLoggedInAtom)
    if (isLoggedIn) {
      const state = ctx.spy(blacklistCurrenciesRemoteModel)
      return Set.create(state.value?.map((it) => it.ref.address) ?? [])
    }
    const state = ctx.spy(blacklistCurrenciesLocalModel).value ?? []
    return Set.create(state.map((it) => it.address))
  })

  return stateAtom.pipe(
    withAssign(() => ({
      blacklistedAddresses: blacklistedAddressesAtom,
      hide: hideAction,
      unhide: unhideAction,
    })),
  )
}

export const blacklistCurrenciesModel = reatomBlacklistCurrencies()
